// src/components/Payment/PayPalSuccess.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Result, Spin, Button, message } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import courseService from "../../services/course.service";

const PayPalSuccess = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState('processing');
    const [messageText, setMessageText] = useState('Traitement du paiement en cours...');

    useEffect(() => {
        const paymentId = searchParams.get('paymentId');
        const payerId = searchParams.get('PayerID');

        if (paymentId && payerId) {
            executePayment(paymentId, payerId);
        } else {
            setStatus('error');
            setMessageText('Paramètres de paiement manquants');
        }
    }, [searchParams]);

    const executePayment = async (paymentId, payerId) => {
        try {
            setStatus('processing');
            setMessageText('Finalisation du paiement avec PayPal...');

            // Utiliser votre service PayPal
            const result = await courseService.executePayPalPayment(paymentId, payerId);

            if (result.status === 'success') {
                setStatus('success');
                setMessageText('Paiement confirmé avec succès !');
                
                // Nettoyer le localStorage
                localStorage.removeItem('paypal_payment_id');
                localStorage.removeItem('paypal_course_id');
                localStorage.removeItem('paypal_user_id');
                
                message.success('Achat terminé avec succès !');
                
                // Redirection après 3 secondes
                setTimeout(() => {
                    navigate('/mes-formations');
                }, 3000);
            } else {
                throw new Error('Paiement non confirmé');
            }

        } catch (error) {
            console.error('Erreur exécution PayPal:', error);
            setStatus('error');
            const errorMsg = error.response?.data || error.message || 'Erreur lors de la confirmation du paiement';
            setMessageText(errorMsg);
            message.error(errorMsg);
        }
    };

    // Reste du composant identique...
    if (status === 'processing') {
        return (
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                minHeight: '50vh',
                flexDirection: 'column'
            }}>
                <Spin size="large" />
                <p style={{ marginTop: 16, fontSize: 16 }}>{messageText}</p>
            </div>
        );
    }

    // ... reste du code de rendu
};

export default PayPalSuccess;